import React from 'react';
// import {
// 	Route,
// 	Link
// } from 'react-router-dom';
import './other.scss';
import { Carousel } from 'antd';
// import ajax from '@/api/public';

class Zizhi extends React.Component{
	constructor (props) {
		super(props)
		this.state={
		}
	}
	render() {
		return(
			<div className="about-child">
			<div className='ys-fengcai home-contain' style={{padding: '50px 150px'}}>
				 <div className='left-contain'>
					 <div className='zc-title text-center' style={{marginBottom: '5px'}}>新浪微博</div>
					 <img src={`${process.env.PUBLIC_URL}/images/sina.png`} />
					 <div className='zc-title text-center' style={{marginTop: '16px', marginBottom: '21px'}}>知乎</div>
					 <img src={`${process.env.PUBLIC_URL}/images/zhihu.jpg`} style={{border: '2px solid #c2c2c2'}}/>
					 <div className='zc-title text-center' style={{marginTop: '30px', marginBottom: '7px'}}>汇川</div>
					 <img src={`${process.env.PUBLIC_URL}/images/huichuan.jpg`} />
					 <div className='zc-title text-center' style={{marginTop: '30px', marginBottom: '7px'}}>360推广</div>
					 <img src={`${process.env.PUBLIC_URL}/images/360express.png`} />
					 <div className='zc-title text-center' style={{marginTop: '30px', marginBottom: '7px'}}>360火眼云</div>
					 <img src={`${process.env.PUBLIC_URL}/images/huoyan.jpg`} />
				 </div>
				 <div className='right-contain'>
					 <div className='zc-title text-center' style={{marginBottom: '5px'}}>小红书</div>
					 <img src={`${process.env.PUBLIC_URL}/images/redbook.png`} />
					 <div className='zc-title text-center' style={{marginBottom: '21px', marginTop: '16px'}}>松塔小店</div>
					 <img src={`${process.env.PUBLIC_URL}/images/songta.jpg`} />
					 <div className='zc-title text-center' style={{marginBottom: '7px', marginTop: '30px'}}>卧龙</div>
					 <img src={`${process.env.PUBLIC_URL}/images/wolong.jpg`} />
					 <div className='zc-title text-center' style={{marginBottom: '7px', marginTop: '30px'}}>360企捷</div>
					 <img src={`${process.env.PUBLIC_URL}/images/qijie.jpg`} />
				 </div>
			</div></div>
		)
	}
}
export default Zizhi;



// WEBPACK FOOTER //
// ./src/components/other/zizhi.jsx